export default {
  title: '品牌设置',
  basicInfo: '基本信息',
};
